var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_16840",
    "data-name": "Raggruppa 16840",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.675,
    height: 14.663,
    viewBox: "0 0 14.675 14.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23694",
    "data-name": "Tracciato 23694",
    d: "M2118.551,375.56c-1.445,0-2.891-.023-4.335.01a1.841,1.841,0,0,1-1.729-1.4,2.1,2.1,0,0,1-.047-.435q0-4.26,0-8.52a1.826,1.826,0,0,1,1.838-1.85c1.611-.006,3.221,0,4.832,0a.615.615,0,1,1,0,1.226q-2.358,0-4.718,0c-.511,0-.732.221-.732.732q0,4.155,0,8.31a.637.637,0,0,0,.734.735h8.308c.52,0,.738-.222.738-.749q0-2.35,0-4.7a.606.606,0,0,1,.553-.658.594.594,0,0,1,.664.581c.01.242,0,.484,0,.726,0,1.395,0,2.789,0,4.183a1.814,1.814,0,0,1-1.376,1.779,1.122,1.122,0,0,1-.282.031Q2120.776,375.562,2118.551,375.56Z",
    transform: "translate(-2112.438 -360.908)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23695",
    "data-name": "Tracciato 23695",
    d: "M2254.4,351.047l2.154,2.153c-.024.026-.068.077-.115.124q-2.294,2.3-4.592,4.586a.835.835,0,0,1-.388.213c-.633.14-1.271.261-1.907.383-.394.075-.537-.078-.457-.474.127-.63.247-1.261.384-1.888a.769.769,0,0,1,.185-.362q2.307-2.323,4.626-4.634C2254.33,351.109,2254.374,351.072,2254.4,351.047Z",
    transform: "translate(-2243.855 -349.066)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23696",
    "data-name": "Tracciato 23696",
    d: "M2408.6,302.6l-2.146-2.146a12.577,12.577,0,0,1,1.075-1,1.517,1.517,0,0,1,2.009,2.234C2409.25,302.022,2408.911,302.3,2408.6,302.6Z",
    transform: "translate(-2395.225 -299.188)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.c1238d88cc93d153a58b2347886f4009.svg";
export { ForwardRef as ReactComponent };